import { __ } from '@wordpress/i18n';
import Button from '../../../../Common/Button';
import SbUtils from '../../../../../Utils/SbUtils';

const WPCodeSnippet = ({ snippet }) => {
    return (
        <div className='snippet-card'>
            <div className='snippet-card-icon'>
                {SbUtils.printIcon('bounding-box')}
            </div>

            <div className='snippet-card-content'>
                <div>
                    <div className='snippet-card-title'>{snippet.title}</div>
                    <div className='snippet-card-description'>{snippet.note}</div>
                </div>

                <Button
                    type='secondary'
                    size='medium'
                    text={snippet.installed ? __('Edit Snippet', 'sb-customizer') : __('Use Snippet', 'sb-customizer')}
                    icon='plus'
                    iconSize='11'
                    icon-position='left'
                    backgroundColor='#f9f9fa50'
                    onClick={() => {
                        window.open(SbUtils.decodeHTMLEntities(snippet.install), '_blank');
                    }}
                />
            </div>
        </div>
    );
}

export default WPCodeSnippet;